:host {
	position: absolute;
	z-index: 10001;
	hyphens: auto;
}
